/* Instafeed's public storefront response supplies standard_resolution only.
 * Keep provider data out of innerHTML, and keep the existing app settings intact. */
if (!customElements.get('swe-instagram-feed')) {
  customElements.define('swe-instagram-feed', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.grid = this.querySelector('.swe-instagram__grid');
      this.dialog = this.querySelector('dialog');
      this.media = this.querySelector('.swe-instagram__media');
      this.querySelector('.swe-instagram__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.media.replaceChildren());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => this.showPost(this.index + Number(button.dataset.direction)));
      });
      this.dialog.addEventListener('keydown', event => {
        if (event.target.tagName === 'VIDEO') return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPost(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.load();
          }
        }, { rootMargin: '600px' });
        this.observer.observe(this);
      } else this.load();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    safeUrl(value, instagram = false) {
      try {
        const url = new URL(value);
        if (url.protocol !== 'https:') return '';
        if (instagram && !['instagram.com', 'www.instagram.com'].includes(url.hostname)) return '';
        return url.href;
      } catch { return ''; }
    }
    async load() {
      try {
        const response = await fetch(this.dataset.feedUrl, { credentials: 'omit', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Feed request failed');
        const feed = await response.json();
        if (feed.meta?.code !== 200 || !Array.isArray(feed.data)) throw new Error('Feed unavailable');
        this.posts = feed.data.slice(0, 8).map(post => ({
          image: this.safeUrl(post.images?.standard_resolution?.url),
          video: this.safeUrl(post.videos?.standard_resolution?.url),
          link: this.safeUrl(post.link, true),
          caption: String(post.caption?.text || ''),
          alt: String(post.alt_text || post.caption?.text || 'Southwestern Equine on Instagram').slice(0, 180)
        })).filter(post => post.image && post.link);
        if (!this.posts.length) throw new Error('No posts');
        const fragment = document.createDocumentFragment();
        this.posts.forEach((post, index) => {
          const tile = document.createElement('a');
          tile.className = 'swe-instagram__tile';
          tile.href = post.link;
          tile.target = '_blank';
          tile.rel = 'noopener';
          tile.setAttribute('aria-label', `Open Instagram post ${index + 1}: ${post.alt}`);
          const image = document.createElement('img');
          image.src = post.image;
          image.alt = post.alt;
          image.width = 600;
          image.height = 600;
          image.loading = 'lazy';
          image.decoding = 'async';
          tile.append(image);
          if (post.video) {
            const play = document.createElement('span');
            play.className = 'swe-instagram__play';
            play.textContent = '▶';
            play.setAttribute('aria-hidden', 'true');
            tile.append(play);
          }
          tile.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || typeof this.dialog.showModal !== 'function') return;
            event.preventDefault();
            this.showPost(index);
            this.dialog.showModal();
          });
          fragment.append(tile);
        });
        this.grid.replaceChildren(fragment);
        this.querySelector('.swe-instagram__status').hidden = true;
      } catch {
        this.grid.dataset.failed = 'true';
      }
    }
    showPost(index) {
      const count = matchMedia('(max-width: 767px)').matches ? Math.min(4, this.posts.length) : this.posts.length;
      this.index = (index + count) % count;
      const post = this.posts[this.index];
      const media = document.createElement(post.video ? 'video' : 'img');
      if (post.video) {
        media.controls = true;
        media.playsInline = true;
        media.preload = 'none';
        media.poster = post.image;
        media.src = post.video;
        media.setAttribute('aria-label', post.alt);
      } else {
        media.src = post.image;
        media.alt = post.alt;
      }
      this.media.replaceChildren(media);
      this.querySelector('.swe-instagram__caption').textContent = post.caption;
      this.querySelector('.swe-instagram__original').href = post.link;
      this.querySelector('.swe-instagram__position').textContent = `${this.index + 1} / ${count}`;
    }
  });
}
